(<template>
  <article class="proweb-booking-stub">
    <p class="proweb-booking-stub__text">{{ prowebBuyerBannerText }}</p>
    <a :href="prowebUrl"
       class="sk-btn sk-btn--default proweb-booking-stub__btn">{{ $gettext('Book in TolkeNett') }}</a>
  </article>
</template>)

<script>
  import ProwebBannerTextMixin from '@/mixins/ProwebBannerTextMixin';
  import constants from '@/modules/constants';

  export default {
    mixins: [ProwebBannerTextMixin],
    computed: {
      prowebUrl() { return constants.PROWEB_URL; }
    }
  };
</script>

<style scoped>
  .proweb-booking-stub {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 550px;
    min-height: 65vh;
    margin: 0 auto;
    padding: 0 15px;
    font-size: 18px;
    text-align: center;
  }

  .proweb-booking-stub__text {
    margin: 0;
    white-space: pre-line;
  }

  .proweb-booking-stub__btn {
    width: auto;
    margin-top: 20px;
    padding: 0 25px;
  }
</style>
